// extracted by mini-css-extract-plugin
export default {"backButton":"PunchupPageShell_backButton__lQ7mc"};